import { z } from 'zod';
import { TimestampMs } from './common.js';
import { RateLimitEvent } from './events.js';
/** Routing metadata only; never include email, credentials, task titles or prompts. */
export const ProviderUsage = z.object({
    accountId: z.string().min(1).max(160),
    agent: z.enum(['claude', 'codex']),
    observedAt: TimestampMs,
    windows: RateLimitEvent.shape.windows,
    plan: z.string().max(80).optional(),
    credits: RateLimitEvent.shape.credits,
    limitReached: RateLimitEvent.shape.limitReached,
});
export const ResetUsagePolicy = z.object({
    mode: z.enum(['auto', 'suggest', 'off']).default('suggest'),
    reservePct: z.number().min(0).max(100).default(15),
    horizonHours: z.number().positive().max(168).default(8),
    maxExtraConcurrent: z.number().int().min(0).max(20).default(2),
    /** Empty scope means all projects/workstreams already authorized by existing policy. */
    projectIds: z.array(z.string().min(1).max(160)).max(200).default([]),
    workstreamIds: z.array(z.string().min(1).max(160)).max(500).default([]),
});
export const ResetUsageSettings = z.record(z.string().min(1).max(160), ResetUsagePolicy);
//# sourceMappingURL=usage.js.map